module.exports = __webpack_public_path__ + "img/hero-image@3x.adb694f2.png";